import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GetEnumNameByValue } from "app/js/src/domain/common/ui-utils";
import { ContentControlledEditingDirective } from 'app/js/src/domain/content-control/editing-directive';
import { ContentControlledEventActionEnum } from 'app/js/src/domain/content-control/enums';
import { ContentControlStudioBaseViewModel } from '../../content-control-studio-base-view-model';

@Component({
  selector: "evrideo-content-control-studio-event",
  templateUrl: "./content-control-studio-event.component.html",
  styleUrl: "./content-control-studio-event.component.scss",
})
export class ContentControlStudioEventComponent {
  @Input() event: ContentControlledEditingDirective;
  @Input("view-model") vm: ContentControlStudioBaseViewModel;
  @Output("revert-clicked") revertButtonClicked = new EventEmitter();

  GetEnumNameByValue = GetEnumNameByValue;
  public get ContentControlledEventActionEnum(): typeof ContentControlledEventActionEnum {
    return ContentControlledEventActionEnum;
  }
  revertEvent(e: Event) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.revertButtonClicked.emit(this.event.id);
  }
  process(img: string) {
    if (!img) return null;
    if (img.startsWith("data:")) {
      return img;
    }
    return `data:image/png;base64,${img}`;
  }
}
